













































































































































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { onlyNumber } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import _ from 'lodash'

@Component

export default class ComponentRemuneracaoRightNavBar extends Vue {
  $refs: {
    menu: any,
  }

  fltLoading: boolean = false
  menu: boolean = false
  filtroProfissional: string = ''
  searchProfissional: any = ''
  loadingProfissionalFilter: boolean = false
  open: boolean = false

  profissionaisDebounced = _.debounce(param => this.getStore.getProfissionais(param), 500)

  get exibirNumeroChamado() {
    return this.getStore.exibirNumeroChamado
  }

  get numeroRepasse() {
    return this.getStore.numeroRepasse
  }

  set numeroRepasse(value: string) {
    this.getStore.setNumeroRepasse(value)
  }

  get contasPagar() {
    return this.getStore.contasPagar
  }

  set contasPagar(value: string) {
    this.getStore.setContasPagar(value)
  }

  get numeroNota() {
    return this.getStore.numeroNota
  }

  set numeroNota(value: string) {
    this.getStore.setNumeroNota(value)
  }

  get valorNota() {
    return this.getStore.valorNota
  }

  set valorNota(value: string) {
    this.getStore.setValorNota(value)
  }

  get numeroChamado() {
    return this.getStore.numeroChamado
  }

  set numeroChamado(value: string) {
    this.getStore.setNumeroChamado(value)
  }

  get getGrupoRepasseItens() {
    return this.getStore.grupoRepasseItens
  }

  set getGrupoRepasseItens(value: any[]) {
    this.getStore.grupoRepasseItens = value
  }

  get getFontePagadoras() {
    return this.getRecebimentoStore.fontePagadoras
  }

  get fontePagadoraId() {
    return this.getStore.fontePagadoraId
  }

  set fontePagadoraId(value: string) {
    this.getStore.setFontePagadoraId(value)
  }

  get somatorioTotalNotas() {
    return this.getStore.somatorioTotalNotas
  }

  set somatorioTotalNotas(value: number) {
    this.getStore.setSomatorioTotalNotas(value)
  }

  get getMenu() {
    return this.menu
  }

  set getMenu(value: boolean) {
    this.menu = value
  }

  get filterLoading() {
    return this.fltLoading
  }

  set filterLoading(value: boolean) {
    this.fltLoading = value
  }

  get getStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get drawer() {
    return this.getStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.getStore.setFilterDrawer(value)
  }

  get grupoRepasse() {
    return this.getStore.grupoRepasse
  }

  set grupoRepasse(value) {
    this.getStore.setGrupoRepasse(value)
  }

  get anoMesReferencia() {
    return this.getStore.anoMesReferencia
  }

  set anoMesReferencia(value) {
    this.getStore.setAnoMesReferencia(value)
  }

  set profissional(value: string) {
    this.filtroProfissional = value
  }

  get getProfissionaisList() {
    return this.getStore.profissionaisExecutantes
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPagina(1)
    if (this.filtroProfissional !== '') {
      this.getStore.setProfissional(this.filtroProfissional)
    }
    await this.getStore.getPrestadorRemuneracaoAll()
    this.getStore.setFilterOn(this.hasAnyFilter())
    if (this.getStore.grupoRepasse !== '') this.ga('remuneracao', 'filtro-grupo-repasse')
    if (this.getStore.anoMesReferencia !== '') this.ga('remuneracao', 'filtro-ano-mes-referencia')
    if (this.getStore.numeroRepasse !== '') this.ga('remuneracao', 'filtro-numero-repasse')
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return this.getStore.grupoRepasse !== ''
      || this.getStore.anoMesReferencia !== ''
      || this.getStore.numeroRepasse !== ''
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  async clear() {
    this.getStore.clearFiltro()
    this.filtroProfissional = '';
    await this.search()
    this.getStore.setFilterOn(false)
  }

  windowHeight: number = 0

  getWindowHeight() {
    const doc: Document = document

    if (doc !== null) {
      this.windowHeight = doc.documentElement.clientHeight
    }
  }

  changeProfissionalExecutante(value) {
    if(value){
      this.profissional = value.userId
    }
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getStore.setProfissionaisExecutantes([])
      return
    }
    
    this.loadingProfissionalFilter = true
    await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }

  async mounted() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }

  async updated() {
    await this.$nextTick(() => { window.addEventListener('resize', this.getWindowHeight) })
  }
}
